// src/components/DailyMenuPdf.js
import React, { useRef } from 'react';
import html2pdf from 'html2pdf.js';
import '../styles/DailyMenuPdf.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons'; // <-- Icône de profil

const DailyMenuPdf = ({ menus }) => {
  const pdfRef = useRef();

  const handleDownload = () => {
    const element = pdfRef.current;
    const opt = {
      margin: 0,
      filename: 'menu_du_jour_IlRialto.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().set(opt).from(element).save();
  };

  const categories = ['Lunchs', 'Plats', 'Desserts'];

  return (
    <div className="pdf-wrapper">
      <button onClick={handleDownload} className="btn-download"> <FontAwesomeIcon icon={faDownload} /></button>

      <div className="menu-pdf-container" ref={pdfRef}>
        <div className="menu-left">
          
            <img className='circle-logo' src="/images/ilrialtologo.jpg" alt="Logo Il Rialto" />
            
          

          <div className="menu-content">
            {categories.map(category => {
              const filtered = menus?.filter(menu =>
                menu.category_name.toLowerCase().includes(category.toLowerCase())
              );
              if (!filtered || filtered.length === 0) return null;

              return (
                <div className="menu-section" key={category}>
                  <h2>{category}</h2>
                  <ul>
                    {filtered.map(menu => (
                      <li key={menu.id}>
                        <p><strong>{menu.name}</strong><span className='prices'>{menu.price}€</span></p>
                        <span className="description">{menu.description}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>

        <div className="menu-right">
          {/* <img src="../../images/illustrationcarte.jpg" alt="illustration" /> */}
        </div>
      </div>
    </div>
  );
};

export default DailyMenuPdf;
